import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=1bf9ebd2"
import script from "./Consent.vue?vue&type=script&lang=js"
export * from "./Consent.vue?vue&type=script&lang=js"
import style0 from "./Consent.vue?vue&type=style&index=0&id=1bf9ebd2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf9ebd2')) {
      api.createRecord('1bf9ebd2', component.options)
    } else {
      api.reload('1bf9ebd2', component.options)
    }
    module.hot.accept("./Consent.vue?vue&type=template&id=1bf9ebd2", function () {
      api.rerender('1bf9ebd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/IncubatorApply/Consent.vue"
export default component.exports